<template>
	<p v-if="visible" class="error-message">
		<slot />
	</p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		visible: Boolean,
	},
});
</script>

<style lang="scss">
.error-message {
	display: block;
	color: $color-error;
	font-size: 1.6rem;
	font-weight: 500;
	line-height: 1.1875;
	animation: animation-name-auto('in') 300ms forwards $easeOutQuad;
	opacity: 0;

	@keyframes #{animation-name-auto('in')} {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}
}
</style>
